import React, { Component } from 'react'
import { compose, graphql, withApollo, Query } from 'react-apollo'

import { Loader } from 'semantic-ui-react'

import Main from './components/Main'

import {
  QueryAllAufschaltungen,
  QueryGetPreferences,
  QueryGetPreferencesFromCache,
  QueryGetAuth0User,
  QueryGetUserInfo,
  MutationUpdatePreferences } from './graphql'

class AppContent extends Component {
  state = { verifiedUserInfo: null, timerId: null }

  componentDidMount () {
    this.startTimer()

    this.interval = setInterval(() => {
      const { client } = this.props
      // Check getPreferences from current cache
      const currentPreferences = client.readQuery({
        query: QueryGetPreferencesFromCache
      })
      const { getPreferences } = currentPreferences
      if (getPreferences && getPreferences.needs_sync) {
        const { updatePreferences } = this.props
        const vars = {
          lang: getPreferences.lang,
          state: getPreferences.state
        }
        updatePreferences({variables: vars})
        // Reset needs_sync flag
        const preferences = {
          ...currentPreferences,
          getPreferences: {
            ...getPreferences,
            needs_sync: false
          }
        }
        client.writeData({data: preferences})
      }
    }, 30000)
  }

  componentWillUnmount () {
    // TODO: sync to server
    clearInterval(this.interval)
  }

  setTimeoutAsync (pollUserInfo, timeout = 5000) {
    return new Promise((resolve) => {
      this.setState(
        {timerId: setTimeout(() => this.timedCount(), timeout)})
      pollUserInfo()
      resolve()
    })
  }

  startTimer = () => {
    this.timedCount()
  }

  async timedCount () {
    await this.setTimeoutAsync(async () => {
      const { QueryAuth0User } = this.props
      const { loading, error, refetch } = QueryAuth0User
      if (loading) return 'Loading...'
      if (error) return `Error! ${error.message}`
      // Check getUserInfo
      const userInfo = QueryAuth0User && QueryAuth0User.getAuth0User
      // Check whether user is already verified
      if (userInfo && userInfo.email_verified) {
        this.stopTimer()
        this.setState({verifiedUserInfo: {getUserInfo: userInfo}})
      } else {
        refetch()
      }
    }, 15000)
  }

  stopTimer = () => {
    clearTimeout(this.state.timerId)
  }
  
  render () {
    const { verifiedUserInfo } = this.state
    return (
      <Query query={QueryGetUserInfo}>
        {({data: data1, loading: loading1, error: error1}) => (

        <Query query={QueryGetPreferences} fetchPolicy='cache-first'>
        {({data: data2, loading: loading2, error: error2}) => (

            <Query query={QueryAllAufschaltungen}>
              {({data: data3, loading: loading3, error: error3}) => {
                if (loading1 || loading2 || loading3) {
                  return (<Loader active size='big' />)
                }
                if (error1) {
                  if (error1.networkError && error1.networkError.statusCode !== 401) {
                    return `Error ${error1}`
                  }
                  // Manipulate userInfo to get correct redirection
                  data1 = {getUserInfo: null}
                }
                if (error2) {
                  if (error2.networkError && error2.networkError.statusCode !== 401) {
                    return `Error ${error2}`
                  }
                  // Manipulate preferences to get correct redirection
                  data2 = {getPreferences: null}
                }
                if (error3) {
                  if (error3.networkError && error3.networkError.statusCode !== 401) {
                    return `Error ${error3}`
                  }
                  // Manipulate allAufschaltungen to get correct redirection
                  data3 = {listAufschaltungen: []}
                }
                const {getUserInfo = null} = verifiedUserInfo ? verifiedUserInfo : data1
                const {getPreferences = null} = data2
                const {listAufschaltungen = []} = data3
                return (
                  <Main aufschaltungen={listAufschaltungen}
                    userInfo={getUserInfo}
                    preferences={getPreferences}
                    redirectToLoginAfterLogout={true} />
                )
              }}
            </Query>
          )}
        </Query>
        )}
      </Query>
    )
  }
}

export default compose(
  withApollo,
  graphql(MutationUpdatePreferences, { name: 'updatePreferences' }),
  graphql(QueryGetAuth0User, { name: 'QueryAuth0User' })
)(AppContent)



// WEBPACK FOOTER //
// ./src/AppContent.js